export const EditFlags_Create = 1;
export const EditFlags_Delete = 4;
export const EditFlags_Update = 2;
export const EditFlags_All = EditFlags_Create | EditFlags_Delete | EditFlags_Update;

export type EditFlagsValue = 1 | 2 | 4;

export const SECURITY_NONE = 'securitynone';
